jQuery(document).ready(function ($) {
	/**
	 * The selector we'll use to find menu toggles.
	 * @type {string}
	 */
	const menuSelector = '.menu-item-has-children a';
	const footerElement = document.querySelector('footer.footer_background_wrapper');

	// only run the majority of the script if we're certain we have a footer element as selected
	// above, to avoid some tiny errors elsewhere

	if (footerElement) {
		const toggleMenuItems = [
			...footerElement.querySelectorAll(menuSelector)
		];

		toggleMenuItems.forEach(toggleMenu => {
			toggleMenu.addEventListener('click', (e) => {
				// lucky for us, the menu we want to open is the sibling of the link we click on. thus,
				// we simoky select the child of our target and toggle an open class. the rest is css
				e.target.nextElementSibling.classList.toggle('open');
				// we also want to add the class to our link itself, so that our arrow can toggle too
				e.target.classList.toggle('open');
			});
		});
	}
})
